<template>
    <div>
        <b-modal
            id="itemFeeModal"
            ref="itemFeeModal"
            :lazy="true"
            title-tag="h2"
            title="New Fee"
        >
            <div v-if="message" class="alert alert-warning" role="alert">
                <i class="cus-error"></i>
                {{ message }}
            </div>

            <b-form-group label="Name:" class label-cols="4" label-for="name">
                <b-input
                    placeholder="Item Name (required)"
                    v-model="data.name"
                    name="name"
                    v-validate="'required'"
                    :class="{
                        'border-danger': errors.has('name')
                    }"
                />
            </b-form-group>

            <b-form-group
                label="Category:"
                class
                label-cols="4"
                label-for="category"
            >
                <v-select
                    id="category"
                    :options="categoriesOptions"
                    v-model="data.category"
                    v-validate="'required'"
                    :class="{ 'border-danger': errors.has('category') }"
                    name="category"
                    label="name"
                    :placeholder="
                        isLoadingCategories
                            ? 'Loading...'
                            : 'Select category (required)'
                    "
                    :selectable="category => !category.unselectable"
                    :disabled="isLoadingCategories"
                />
            </b-form-group>

            <b-form-group
                label="Print on Invoice:"
                class
                label-cols="4"
                label-for="is_print_on_invoice"
            >
                <b-select
                    v-model="data.is_print_on_invoice"
                    class="form-control"
                    :options="[
                        { text: 'Yes', value: 1 },
                        { text: 'No', value: 0 }
                    ]"
                    name="is_print_on_invoice"
                ></b-select>
            </b-form-group>

            <b-form-group label="Price:" class label-cols="4" label-for="price">
                <b-row class="mx-0">
                    <b-input
                        placeholder="Unit Price"
                        v-model="data.price"
                        v-validate="''"
                        name="price"
                        type="number"
                        step="0.01"
                        class="col-3 mr-1"
                        :class="{
                            'border-danger': errors.has('price')
                        }"
                    />
                    <b-select
                        v-model="data.cost_type"
                        class="col form-control"
                        :options="COST_TYPE"
                        name="cost_type"
                        disabled
                    ></b-select>
                </b-row>
            </b-form-group>

            <template v-slot:modal-footer="{ close }">
                <loader v-if="isLoading" :margin="1" />

                <b-button
                    class="mr-auto"
                    variant="secondary"
                    @click="close"
                    v-if="!isLoading"
                >
                    <span v-if="isWellnessPlan">Cancel</span>
                    <span v-else>Back</span>
                </b-button>

                <b-button
                    v-if="!isLoading"
                    variant="primary"
                    @click="save(close)"
                >
                    Save
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import vSelect from "vue-select";
import { find, filter, forEach } from "lodash";
import ItemsServices from "@/services/items";

export default {
    components: {
        vSelect,
        Loader: () => import("@/module/commons/loader")
    },
    mixins: [],
    props: {
        isWellnessPlan: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoadingCategories: false,
            categoriesOptions: [],
            data: {
                name: "",
                category: null,
                is_print_on_invoice: 1,
                cost_type: 1,
                price: 0
            },
            message: "",
            isLoading: false
        };
    },
    watch: {},
    computed: {
        groupedCategories() {
            return this.$store.getters["inventory/groupedCategories"];
        }
    },
    mounted() {},
    methods: {
        open(params) {
            this.isLoadingCategories = true;

            Promise.all([this.$store.dispatch("inventory/getCategory")])
                .then(() => {
                    const filteredCategories = filter(
                        this.groupedCategories,
                        category => {
                            if (
                                (category.id && category.id === "it#11") ||
                                (category.item_type &&
                                    category.item_type.id === 11)
                            ) {
                                return true;
                            }
                            return false;
                        }
                    );

                    forEach(filteredCategories, category => {
                        this.categoriesOptions.push(category);
                    });

                    this.data.category = find(
                        this.categoriesOptions,
                        category => !category.unselectable
                    );
                })
                .finally(() => {
                    this.isLoadingCategories = false;
                });

            this.$refs.itemFeeModal.show();

            if (params.name) {
                this.data.name = params.name;
            }
        },
        async save(close) {
            if (await this.$validator.validateAll()) {
                this.isLoading = true;

                let params = {
                    cost_type_id: this.data.cost_type,
                    due: 0,
                    discount_amount: "0",
                    discount_type: "0",
                    is_print_on_invoice: this.data.is_print_on_invoice,
                    item_type_category_id: this.data.category.id,
                    module: "WELLNESS_FEE",
                    name: this.data.name,
                    price: this.data.price,
                    type: this.data.category.item_type.id
                };

                ItemsServices.post(params).then(item => {
                    this.isLoading = false;
                    this._message("Item added successfully", "success");
                    this.close();
                    this.$emit("saved", { ...item, isNewCreated: true });
                });
            }
        },
        close() {
            this.$refs.itemFeeModal.hide();
        }
    }
};
</script>
<style lang="scss">
#category {
    .vs__dropdown-option--disabled {
        &:hover {
            background: white;
        }
        color: black;
        font-weight: bold;
        margin-left: 0 !important;
    }
    .vs__dropdown-option {
        margin-left: 0.3rem;
    }
}
</style>
